import React from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import Loader from '../../../../components/Loader/Loader'
import WhyHostFormBlock3 from '../../../../components/siteadmin/WhyHostPageSettings/WhyHostFormBlock3/WhyHostFormBlock3'
import getWhyHostPageSettings from './getWhyHostPageSettings.graphql';
import { withQuery } from '../../../../hoc/withGraphql';

import s from './WhyHostBlock3.css';

const WhyHostBlock3 = (props) => {

    const { data: { loading, getWhyHostPage }, title } = props;
    if (loading) return <Loader type={"text"} />;

    let settingsCollection = {};
    const dynamicMap = {};

    const BLOCK3_ACTIVE_FIELDS = ['whyBlockTitle1', 'whyBlockContent1', 'whyBlockTitle2', 'whyBlockContent2'];
    getWhyHostPage?.forEach((item) => {
        settingsCollection[item.name] = item.value;

        if (BLOCK3_ACTIVE_FIELDS.includes(item.name)) {
            item.dynamicWhyHostInfoBlock?.forEach((dynItem) => {
                if (!dynamicMap[dynItem.language]) {
                    dynamicMap[dynItem.language] = { language: dynItem.language };
                }
                dynamicMap[dynItem.language][dynItem.name] = dynItem.value;
            });
        }
    });

    const dynamicValues = Object.values(dynamicMap);

    settingsCollection.dynamicWhyHostInfoBlock = dynamicValues.length > 0
        ? dynamicValues
        : [{
            language: 'en',
            whyBlockTitle1: settingsCollection.whyBlockTitle1,
            whyBlockContent1: settingsCollection.whyBlockContent1,
            whyBlockTitle2: settingsCollection.whyBlockTitle2,
            whyBlockContent2: settingsCollection.whyBlockContent2,
        }];
    return <WhyHostFormBlock3 initialValues={settingsCollection} title={title} />;
}

WhyHostBlock3.defaultProps = {
    data: {
        loading: false
    }
};

export default compose(
    withStyles(s),
    withQuery(getWhyHostPageSettings, {
        options: {
            fetchPolicy: 'network-only',
            ssr: false
        }
    }),
)(WhyHostBlock3);